import React from 'react';

interface NavbarProps {
  onRefresh: () => void;
  onSignOut?: () => void;
  showSignOut?: boolean;
  username?: string;
}

export const Navbar: React.FC<NavbarProps> = ({ 
  onRefresh, 
  onSignOut,
  showSignOut = false,
  username
}) => (
  <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
    <div className="container">
      <a className="navbar-brand" href="#">Document Processing Monitor</a>
      
      <div className="d-flex align-items-center">
        {showSignOut && username && (
          <span className="text-light me-3">
            {username}
          </span>
        )}
        
        <button 
          className="btn btn-outline-light me-2" 
          onClick={onRefresh}
        >
          <i className="bi bi-arrow-clockwise"></i> Refresh
        </button>
        
        {showSignOut && onSignOut && (
          <button 
            className="btn btn-outline-light" 
            onClick={onSignOut}
          >
            <i className="bi bi-box-arrow-right"></i> Sign Out
          </button>
        )}
      </div>
    </div>
  </nav>
);